import { pdfjs } from 'react-pdf'

// Worker is copied to public/ at build time by copy-webpack-plugin. The one
// worker setup for every react-pdf viewer (floor-crud, guard-activity, …).
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js'

export { pdfjs }
